import {
  SET_STATE_DISABLED_FOR_ADMIN_ENTRY_DETAIL,
  SET_STATES_FOR_ADMIN_ENTRY_DETAIL,
  SET_VIRTUAL_ENTRIES_TO_MODIFY_FOR_ADMIN_ENTRY_DETAIL,
  SET_READONLY_INFO_FOR_ADMIN_ENTRY_DETAIL,
  SET_SUMMARY_FOR_ADMIN_ENTRY_DETAIL,
  CLEAR_ROSTER_POSITION_FOR_ADMIN_ENTRY_DETAIL,
  SET_COUNTRIES_FOR_ADMIN_ENTRY_DETAIL,
  UPDATE_ROSTER_INFO_FOR_ADMIN_ENTRY_DETAIL,
  SEARCHING_MEMBER_FINISHED_FOR_ADMIN_ENTRY_DETAIL,
  SEARCHING_MEMBER_STARTS_FOR_ADMIN_ENTRY_DETAIL,
  SET_MEMBER_SEARCH_FIELD_FOR_ADMIN_ENTRY_DETAIL,
  MOVE_ROSTER_POSITION_UP_FOR_ADMIN_ENTRY_DETAIL,
  MOVE_ROSTER_POSITION_DOWN_FOR_ADMIN_ENTRY_DETAIL,
  SET_BOWLER_AVG_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION,
  SET_IS_PROFESSIONAL_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION,
  SET_ROSTER_POSITIONS_FOR_ADMIN_ENTRY_DETAIL,
  SET_ROSTER_MODAL_VISIBILITY_FOR_ADMIN_ENTRY_DETAIL,
  SET_ENTRY_DETAIL_BALANCE_FOR_ADMIN,
  SET_ENTRY_DETAIL_CAPTAINID_FOR_ADMIN,
  DISPLAY_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL,
  SET_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL,
  CANCEL_ENTRY_DETAIL_PAYMENT_MODAL,
  DISPLAY_ENTRY_DETAIL_PAYMENT_MODAL,
  HIDE_ENTRY_DETAIL_PAYMENT_MODAL,
  SET_ENTRY_DETAIL_ID_FOR_ADMIN,
  SET_ENTRY_DETAIL_TOURNAMENT_FOR_ADMIN,
  DISPLAY_ENTRY_DETAIL_CHANGE_SQUAD_MODAL,
  DISPLAY_ENTRY_DETAIL_CHANGE_EVENT_MODAL,
  SET_ENTRY_DETAIL_COORDINATOR_FOR_ADMIN,
  SET_ENTRY_DETAIL_CAPTAIN_FOR_ADMIN,
  SHOW_HIDE_ENTRY_DETAIL_COORDINATOR_MODAL_FOR_ADMIN,
  SHOW_HIDE_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN,
  SET_IS_NEW_CAPTAIN_ENTRY_DETAIL,
  SET_AVAILABLE_BOWLERS_FOR_ADMIN_ENTRY_DETAIL,
  SHOW_HIDE_ENTRY_DETAIL_REFUND_MODAL_FOR_ADMIN,
  SET_ENTRY_DETAIL_CREDIT_PURCHASE_TRANSACTIONS,
  SHOW_HIDE_ENTRY_DETAIL_REACTIVATION_MODAL_FOR_ADMIN,
  SET_ADMIN_ENTRY_DETAIL_REFUND_TYPE
} from './constants';

export const setAvailableBowlersInState = bowlers => ({
  type: SET_AVAILABLE_BOWLERS_FOR_ADMIN_ENTRY_DETAIL,
  payload: bowlers
});

export const setEntryStateDisabled = disabled => ({
  type: SET_STATE_DISABLED_FOR_ADMIN_ENTRY_DETAIL,
  payload: disabled
});
 
export const setEntryReadOnlyInfo = readOnlyInfo => ({
  type: SET_READONLY_INFO_FOR_ADMIN_ENTRY_DETAIL,
  payload: readOnlyInfo
});

export const setEntrySummary = summary => ({
  type: SET_SUMMARY_FOR_ADMIN_ENTRY_DETAIL,
  payload: summary
});

export const clearRosterPosition = index => ({
  type: CLEAR_ROSTER_POSITION_FOR_ADMIN_ENTRY_DETAIL,
  payload: index
});

export const setVirtualEntriesToModify = virtualEntriesToModify => ({
  type: SET_VIRTUAL_ENTRIES_TO_MODIFY_FOR_ADMIN_ENTRY_DETAIL,
  payload: virtualEntriesToModify
});

export const setStates = states => ({
  type: SET_STATES_FOR_ADMIN_ENTRY_DETAIL,
  payload: states
});

export const setCountries = countries => ({
  type: SET_COUNTRIES_FOR_ADMIN_ENTRY_DETAIL,
  payload: countries
});

export const updateRosterInfo = rosterInfo => ({
  type: UPDATE_ROSTER_INFO_FOR_ADMIN_ENTRY_DETAIL,
  payload: rosterInfo
});

export const searchingFinished = () => ({
  type: SEARCHING_MEMBER_FINISHED_FOR_ADMIN_ENTRY_DETAIL
});

export const searchingStarts = rosterPosition => ({
  type: SEARCHING_MEMBER_STARTS_FOR_ADMIN_ENTRY_DETAIL,
  payload: rosterPosition
});

export const setMemberSearchField = roster => ({
  type: SET_MEMBER_SEARCH_FIELD_FOR_ADMIN_ENTRY_DETAIL,
  payload: roster
});

export const moveRosterUp = index => ({
  type: MOVE_ROSTER_POSITION_UP_FOR_ADMIN_ENTRY_DETAIL,
  payload: index
});

export const moveRosterDown = index => ({
  type: MOVE_ROSTER_POSITION_DOWN_FOR_ADMIN_ENTRY_DETAIL,
  payload: index
});

export const setMemberAvgField = (position, value) => ({
  type: SET_BOWLER_AVG_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION,
  payload: {position, value}
});

export const setIsProfessional = (position, value) => ({
  type: SET_IS_PROFESSIONAL_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION,
  payload: {position, value}
});

export const setRosterPositions = rosterPositions => ({
  type: SET_ROSTER_POSITIONS_FOR_ADMIN_ENTRY_DETAIL,
  payload: rosterPositions
});

export const displayEntryModal = visible => ({
  type: SET_ROSTER_MODAL_VISIBILITY_FOR_ADMIN_ENTRY_DETAIL,
  payload: visible
});

export const displaySquadChangeModal = showModal => ({
  type: DISPLAY_ENTRY_DETAIL_CHANGE_SQUAD_MODAL,
  payload: showModal
});

export const displayEventChangeModal = showModal => ({
  type: DISPLAY_ENTRY_DETAIL_CHANGE_EVENT_MODAL,
  payload: showModal
});

export const setEntryDetailBalance = balance => ({
  type: SET_ENTRY_DETAIL_BALANCE_FOR_ADMIN,
  payload: balance
});

export const setEntryDetailCaptainId = captainId => ({
  type: SET_ENTRY_DETAIL_CAPTAINID_FOR_ADMIN,
  payload: captainId
});

export const setEntryDetailTournament = tournament => ({
  type: SET_ENTRY_DETAIL_TOURNAMENT_FOR_ADMIN,
  payload: tournament
});

export const setEntryDetailId = entryId => ({
  type: SET_ENTRY_DETAIL_ID_FOR_ADMIN,
  payload: entryId
});

export const displayPaymentLogHistory = optionalShowLog => ({
  type: DISPLAY_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL,
  payload: optionalShowLog
});

export const setPaymentLogHistory = paymentLogHistory => ({
  type: SET_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL,
  payload: paymentLogHistory
});

export const cancelEntryDetailPaymentModal = () => ({
  type: CANCEL_ENTRY_DETAIL_PAYMENT_MODAL
});

export const displayEntryDetailPaymentModal = () => ({
  type: DISPLAY_ENTRY_DETAIL_PAYMENT_MODAL
});

export const hideEntryDetailPaymentModal = () => ({
  type: HIDE_ENTRY_DETAIL_PAYMENT_MODAL
});

export const setEntryDetailCoordinator = coordinator => ({
  type: SET_ENTRY_DETAIL_COORDINATOR_FOR_ADMIN,
  payload: coordinator
});

export const setEntryDetailCaptain = captain => ({
  type: SET_ENTRY_DETAIL_CAPTAIN_FOR_ADMIN,
  payload: captain
});

export const displayEntryDetailCoordinatorModal = () => ({
  type: SHOW_HIDE_ENTRY_DETAIL_COORDINATOR_MODAL_FOR_ADMIN,
  payload: true
});

export const hideEntryDetailCoordinatorModal = () => ({
  type: SHOW_HIDE_ENTRY_DETAIL_COORDINATOR_MODAL_FOR_ADMIN,
  payload: false
});

export const cancelEntryDetailCoordinatorModal = () => ({
  type: SHOW_HIDE_ENTRY_DETAIL_COORDINATOR_MODAL_FOR_ADMIN,
  payload: false
});

export const displayEntryDetailChangeCaptainModal = () => ({
  type: SHOW_HIDE_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN,
  payload: true
});

export const hideEntryDetailChangeCaptainModal = () => ({
  type: SHOW_HIDE_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN,
  payload: false
});

export const cancelEntryDetailChangeCaptainModal = () => ({
  type: SHOW_HIDE_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN,
  payload: false
});

export const setIsNewCaptainOnSearch = isNew => ({
  type: SET_IS_NEW_CAPTAIN_ENTRY_DETAIL,
  payload: isNew
});

export const setVisibleEntryDetailRefundModal = visible => ({
  type: SHOW_HIDE_ENTRY_DETAIL_REFUND_MODAL_FOR_ADMIN,
  payload: visible
});

export const setCreditPurchaseTransactions = creditPurchaseTransactions => ({
  type: SET_ENTRY_DETAIL_CREDIT_PURCHASE_TRANSACTIONS,
  payload: creditPurchaseTransactions
});

export const displayReactivationModal = showModal => ({
  type: SHOW_HIDE_ENTRY_DETAIL_REACTIVATION_MODAL_FOR_ADMIN,
  payload: showModal
});

export const setAdminEntryDetailRefundType = refundType => ({
  type: SET_ADMIN_ENTRY_DETAIL_REFUND_TYPE,
  payload: refundType
});


// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/actionTypes.js